import ReactDOM from 'react-dom';
import { dialogPageSpinner } from '../dialog';
import { bodyAppendDivElement, createDivElement } from '../utils/dom';
import { PageErrorProps, PageErrorView } from './page-error';
import './style.less';

export type DialogPageErrorProps = PageErrorProps & { getContainer?: () => Element | null };

export const dialogPageErrorInner = {
  show: (props?: DialogPageErrorProps) => {
    if (props?.getContainer?.()) {
      const root = props.getContainer() as Element;
      const div = createDivElement();
      root.append(div);
      ReactDOM.render(<PageErrorView {...props} />, div);
    } else {
      const { divElement } = bodyAppendDivElement();
      ReactDOM.render(<PageErrorView {...props} />, divElement);
    }
  },
  hide: () => {
    dialogPageSpinner.hide();
    const element = document.querySelector('.v-dialog-page-error');
    if (element) {
      const elementParent = document.querySelector('.v-dialog-page-error')?.parentNode;
      document.body.removeChild(elementParent as Node);
    }
  },
};
